import React, { FC } from 'react';
import { TradingSummaryReport, ReportItem } from '../../TradingSummarytModel';
import { DataTable, ColumnConfig } from '../../../DataTable';

interface Props {
  reportData?: TradingSummaryReport;
  translation: any;
  columns: ColumnConfig<ReportItem>[];
  selectedColumns: string[];
  onSelectColumns(columns: string[]): void;
}

export const TradingReports: FC<Props> = ({ reportData, translation, columns, selectedColumns, onSelectColumns }) => {
  const rows = reportData?.items || [];

  return <DataTable columns={columns} data={rows} translation={translation} columnSelect selectedColumns={selectedColumns} onSelectColumns={onSelectColumns} emptyMessage={translation.reports_EmptyTableMessage} />;
};
